import { IonRange } from '@ionic/react';
import { motion } from 'motion/react';
import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';
import { OwnAiTitle } from '../../components/Title';

export const PersonalityStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      padding: 0 24px;
      display: flex;
      flex-direction: column;
    }

    .range-labels {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0;

      .range-label {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
`;

export const PersonalityRangeItemStyles = styled(motion.div)`
  margin: 8px 0;
`;

export const PersonalityRangeStyles = styled(IonRange)`
  width: 100%;
  flex: 0;
  padding: 0 4px;
  border-radius: 8px;

  --bar-background: #765279;
  --bar-background-active: linear-gradient(
    116deg,
    #b07eff 16.47%,
    #ffc9fb 83.53%
  );
  --bar-height: 8px;
  --bar-border-radius: 8px;
  --knob-background: #ffc9fb;
  --knob-size: 24px;
  --pin-background: none;
  --pin-color: none;
`;

export const PersonalityTitleStyles = styled(OwnAiTitle)`
  margin: 0 0 24px;
`;

export const PersonalityAiIconStyles = styled.div`
  width: 150px;
  aspect-ratio: 1/1;
  flex-shrink: 0;
  margin: 12px auto;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(180deg, #6b466a 0%, #43285b 100%);
  position: relative;

  & > img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    width: calc(100% - 10px);
    aspect-ratio: 1/1;
    object-fit: contain;
  }
`;

export const PersonalitySmileStyles = styled.img`
  width: 24px;
  aspect-ratio: 1/1;
  margin: 0;
  font-size: 0;
  line-height: 0;
  display: inline-block;
`;
